import React from "react";
import { discountApplies, subscriptionHasEndDate } from "./SubscriptionUtils";
import { findEnumObject } from "utilities/enumutils";
import SubscriptionCard from "./SubscriptionCard";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { SectionTemplateHeader } from "components/MainSectionTemplate/SectionTemplateHeader";
import ChangeNextSubscriptionModal from "./ChangeNextSubscriptionModal";
import ChangeActiveSubscriptionModal from "./ChangeActiveSubscriptionModal";
import { CustomSection } from "components/MainSectionTemplate/types";
interface Props {
  activeSubscription: server.dto.Subscription
  subscriptions: server.dto.Subscription[]
  nextSubscription: server.dto.NextSubscription
  discount?: server.dto.ClientDiscount
  client: server.dto.Client
  billingDetails: server.dto.ClientBillingDetails
}

const SubscriptionsPanel = (props: Props) => {
  const activeSubscriptionHasEndDate = subscriptionHasEndDate(props.activeSubscription);
  const nextDiscountApplies = discountApplies(props.activeSubscription.end, props.discount?.until);
  const nextDiscountPercentage = (nextDiscountApplies) ? props.activeSubscription.discount : null;

  const [showChangeActiveSubscriptionModal, setShowChangeActiveSubscriptionModal] = React.useState<boolean>(false);
  const [showChangeNextSubscriptionModal, setShowChangeNextSubscriptionModal] = React.useState<boolean>(false);


  return <SectionPanel.Panel
    header={<SectionTemplateHeader>{RESX.Subscription.Subscriptions}</SectionTemplateHeader>}
  >
    <div className="list-with-gaps line-layout">
      <div className="list-with-gaps-body">
        {props.subscriptions.map((subscription, i) => {
          const isActive = (subscription.subscriptionId === props.activeSubscription.subscriptionId);
          const onClick = isActive ? () => setShowChangeActiveSubscriptionModal(true) : null;
          return <SubscriptionCard
            key={i}
            subscriptionId={subscription.subscriptionId}
            type={findEnumObject(subscription.type, serverReference.subscriptionTypes)}
            start={subscription.start}
            useColor={false}
            billingCycle={findEnumObject(subscription.billingCycle, serverReference.billingCycles)}
            users={subscription.internalUsers}
            discount={subscription.discount}
            discountReason={subscription.discountReason}
            invoice={subscription.invoice}
            onClick={onClick}
          />;
        })}
      </div>
    </div>

    {activeSubscriptionHasEndDate && <>
      <div className="margin-top margin-bottom s1_gray" style={{ textAlign: "center", fontSize: 20 }} >
        🡻
      </div>

      <div className="list-with-gaps line-layout">
        <div className="list-with-gaps-body">
          <SubscriptionCard
            type={findEnumObject(props.nextSubscription.type, serverReference.subscriptionTypes)}
            start={props.activeSubscription.end}
            useColor={true}
            billingCycle={findEnumObject(props.nextSubscription.billingCycle, serverReference.billingCycles)}
            discount={nextDiscountPercentage}
            discountReason={props.activeSubscription.discountReason}
            users={props.nextSubscription.internalUsers}
            onClick={() => setShowChangeNextSubscriptionModal(true)}
            isNext
          />
        </div>
      </div>
    </>}

    <ChangeActiveSubscriptionModal
      client={props.client}
      activeSubscription={props.activeSubscription}
      nextSubscription={props.nextSubscription}
      billingDetails={props.billingDetails}
      subscriptions={props.subscriptions}

      isOpen={showChangeActiveSubscriptionModal}
      onClose={() => { setShowChangeActiveSubscriptionModal(false); }} />

    <ChangeNextSubscriptionModal
      client={props.client}
      activeSubscription={props.activeSubscription}
      nextSubscription={props.nextSubscription}
      isOpen={showChangeNextSubscriptionModal}
      onClose={() => { setShowChangeNextSubscriptionModal(false); }} />
  </SectionPanel.Panel>
};

export const subscriptionPanelSection = (props: Props): CustomSection => {
  return {
    key: "subscription",
    type: "custom",
    render: () => <SubscriptionsPanel key="subscriptions" {...props} />
  }
}